// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dd7e2424","239":"94ed5afd","732":"69702498"}[chunkId] + ".chunk.js";
};